import { render } from "./QuickAction.vue?vue&type=template&id=2471fc85"
import script from "./QuickAction.vue?vue&type=script&lang=js"
export * from "./QuickAction.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__